import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AppMessageService } from '../../../shared/services/app-message/app-message.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'core-address-input',
  templateUrl: './address-input.component.html',
  styleUrls: ['./address-input.component.scss'],
})
export class AddressInputComponent {
  @Input() form!: FormGroup; // Parent formdan alınan form
  @Input() showMapButton: boolean = true;
  @Output() openModal: EventEmitter<void> = new EventEmitter<void>();
  @Input() label: string | null = null;
  @Input() addressFormName: 'address' | 'fromAddress' | 'toAddress' = 'address';

  constructor(private readonly appMessageService: AppMessageService,private readonly translate: TranslateService) {}

  openAddressModal() {
    this.openModal.emit(); // Parent component'e modal açmasını bildir
  }

  onNavigateIconClick(): void {
    const adresFormValue = this.form?.value?.address;
    if (adresFormValue?.formattedAddress) {
      // Navigate to Google Maps with formatted address
      const formattedAddress = encodeURIComponent(
        adresFormValue.formattedAddress
      );
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${formattedAddress}`,
        '_blank'
      );
    } else if (adresFormValue?.latitude && adresFormValue?.longitude) {
      // Navigate to Google Maps with latitude and longitude
      const latitude = adresFormValue.latitude;
      const longitude = adresFormValue.longitude;
      window.open(
        `https://www.google.com/maps?q=${latitude},${longitude}`,
        '_blank'
      );
    } else {
      this.appMessageService.warningToast(
        this.translate.instant('common.warning'),
        this.translate.instant('common.no-valid-address')
      );
     return
    }
  }
  get addressDescriptionValue(): string {
    return this.form?.value?.[this.addressFormName]?.addressDescription || '';
  }
  get getFormattedAddressValue(): string {
    return (
      this.form?.value?.[this.addressFormName]?.formattedAddress ||
      this.form?.value?.[this.addressFormName]?.street ||
      ''
    );
  }
  get hasAddressDescription(): boolean {
    return !!this.form?.value?.[this.addressFormName]?.addressDescription;
  }
}
